__turbopack_context__.v({
  "copied": "CopyButton-module__VNBpYq__copied",
  "copyLabel": "CopyButton-module__VNBpYq__copyLabel",
  "icon": "CopyButton-module__VNBpYq__icon",
  "root": "CopyButton-module__VNBpYq__root",
});
